import type { ResponseWithType, PhotoRest, PhotosResponse } from './types';

const photosResponse = ({
  data,
  meta,
}: ResponseWithType<PhotoRest[], { total: number }>): PhotosResponse => {
  return {
    __typename: 'PhotosResponse',
    meta: meta!,
    photos: data.map((photo) => ({
      ...photo,
      photosAppPath: `/groups/${photo.group}/photos/${photo.id}`,
      __typename: 'Photo',
    })),
  };
};

export default photosResponse;
